<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :visible.sync="dialogVisible" destroy-on-close title="验证已绑定手机号码" width="600px">
		<div>
			<el-form @submit.native.prevent ref="formRef" :model="form" :rules="rules" label-position="top" label-width="120px">
				<el-row :gutter="20">
					<el-col :span="24">
						
						<el-form-item label="目前已绑定手机号码：" prop="phone">
							<el-input v-model.trim="form.phone" placeholder="请输入手机号码" disabled/>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="已绑定手机号码验证码：" prop="verifyCode">
							<div style="display: flex; align-items: center">
								<el-input v-model.trim="form.verifyCode" autocomplete="off" placeholder="短信验证码"></el-input>
								<el-button :disabled="waitNum > 0" plain type="primary" @click="toSendMsg">
									{{ waitNum > 0 ? waitNum + '秒后重新发送' : '发送验证码' }}
								</el-button>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">关闭</el-button>
				<el-button size="small" type="primary" @click="handleNext"> 下一步 </el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import { getMemberSms } from '@/api/user/login';
import TMessage from '@/utils/TMessage';
import { postMemberPhoneOld } from '@/api/user/user.js';
import mtils from 'mtils';
import { mapGetters } from 'vuex';

export default {
	name: 'VerifyOldPhone',
	data() {
		//校验 手机号码
		const validatePhone = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入手机号码'));
			}
			if (!mtils.validation.isMobile(value)) {
				return callback(new Error('手机号码格式不正确'));
			}
			callback();
		};
		return {
			form: {
				phone: '',
				verifyCode: '',
				verifyKey: ''
			},
			rules: {
				phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
				verifyCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
			},
			dialogVisible: false,
			waitNum: 0,
			wtimer: null
		};
	},
	watch: {
		dialogVisible(val) {
			if (!val) {
				this.stopWait();
				this.resetForm();
			}
			if (val) {
				this.form.phone = this.uinfo.accountPhone;
			}
		}
	},
    computed: {
		...mapGetters('User', ['uinfo'])
	},
	methods: {
		//发送短信接口
		toSendMsg() {
			this.startWait();
			getMemberSms(this.form.phone).then(res => {
				let { code, data, msg } = res;
				if (code == 200) {
					this.form.verifyKey = data;
					TMessage.success('验证码已发送');
				} else if (msg) {
					this.stopWait();
					TMessage.warning(msg);
				} else {
					this.stopWait();
					TMessage.warning('短信发送失败');
				}
			});
		},

		//开始倒计时
		startWait() {
			this.waitNum = 60;
			if (this.wtimer) {
				this.stopWait();
			}
			this.wtimer = setInterval(() => {
				this.waitNum--;
				// 倒计时结束
				if (this.waitNum <= 0) {
					this.stopWait();
				}
			}, 1000);
		},

		//停止倒计时
		stopWait() {
			clearInterval(this.wtimer);
			this.wtimer = null;
			this.waitNum = 0;
		},

		handleClose() {
			this.resetForm();
			this.$emit('cancel');
		},

		resetForm() {
			this.$refs['formRef'].resetFields();
		},

		handleNext() {
			this.$refs['formRef'].validate(valid => {
				if (valid) {
					postMemberPhoneOld(this.form).then(res => {
						let { code, data, msg } = res;
						if (code == 200) {
							TMessage.success('验证成功,请绑定新手机号码');
							this.$emit('nextInfo');
						} else if (msg) {
							TMessage.warning(msg);
						} else {
							TMessage.warning('验证失败');
						}
					});
				}
			});
		}
	},
	// 销毁组件
	beforeDestroy() {
		this.stopWait();
	}
};
</script>

<style lang="less" scoped>
// 弹出框重置样式
/deep/ .el-dialog__header {
	border-bottom: 1px dashed #e2e8f0;
	margin-right: 0;
	background: #f8fafc;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}
</style>
